export const PUBLISHING_DOCUMENT_STATUS = {
  UNINITIALIZED: 'UNINITIALIZED',
  SENT_TO_PREPARE: 'SENT_TO_PREPARE',
  SUCCESS: 'SUCCESS',
  PREPARING_ERROR: 'PREPARING_ERROR'
}
